import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

function ResidentResponse() {
  const { notificationId, residentId } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const response = await fetch(
        `${API_URL}/api/response/${notificationId}/${residentId}`
      );
      const result = await response.json();
      
      if (result.success) {
        setData(result);
        if (result.already_responded) {
          setSelectedStatus(result.response.status);
          setSubmitted(true);
        }
      } else {
        alert('データの取得に失敗しました');
      }
      setLoading(false);
    } catch (error) {
      console.error('データ取得エラー:', error);
      alert('サーバーに接続できません');
      setLoading(false);
    }
  };

  const handleSubmit = async (status) => {
    if (!window.confirm('この内容で送信してもよろしいですか？')) {
      return;
    }

    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const response = await fetch(`${API_URL}/api/response`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          notification_id: notificationId,
          resident_id: residentId,
          status: status
        }),
      });

      const result = await response.json();

      if (result.success) {
        setSelectedStatus(status);
        setSubmitted(true);
        alert('応答を送信しました。ありがとうございます。');
      } else {
        alert('エラー: ' + result.message);
      }
    } catch (error) {
      console.error('送信エラー:', error);
      alert('応答の送信に失敗しました');
    }
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f5f5f5'
      }}>
        <div>読み込み中...</div>
      </div>
    );
  }

  if (!data) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '10px',
          textAlign: 'center'
        }}>
          <h2>エラー</h2>
          <p>データが見つかりませんでした</p>
        </div>
      </div>
    );
  }

  const getStatusText = (status) => {
    switch(status) {
      case 'safe': return '大丈夫です';
      case 'danger': return '危ないですが、まだ大丈夫です';
      case 'emergency': return 'もうだめです。すぐ避難したい';
      default: return '';
    }
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'safe': return '#4CAF50';
      case 'danger': return '#FF9800';
      case 'emergency': return '#f44336';
      default: return '#999';
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '600px',
        margin: '0 auto'
      }}>
        {/* ヘッダー */}
        <div style={{
          backgroundColor: '#4CAF50',
          color: 'white',
          padding: '30px',
          borderRadius: '10px 10px 0 0',
          textAlign: 'center'
        }}>
          <h1 style={{ margin: '0 0 10px 0', fontSize: '24px' }}>
            生存確認システム
          </h1>
          <p style={{ margin: 0, fontSize: '14px' }}>
            安全確認にご協力ください
          </p>
        </div>

        {/* メインコンテンツ */}
        <div style={{
          backgroundColor: 'white',
          padding: '30px',
          borderRadius: '0 0 10px 10px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}>
          {/* 住民情報 */}
          <div style={{
            marginBottom: '30px',
            padding: '20px',
            backgroundColor: '#f9f9f9',
            borderRadius: '8px'
          }}>
            <h3 style={{ marginTop: 0, color: '#333' }}>ご本人確認</h3>
            <p style={{ margin: '5px 0', fontSize: '18px', fontWeight: 'bold' }}>
              {data.resident.name} 様
            </p>
            <p style={{ margin: '5px 0', color: '#666' }}>
              {data.resident.address}
            </p>
          </div>

          {/* メッセージ */}
          <div style={{
            marginBottom: '30px',
            padding: '20px',
            backgroundColor: '#e3f2fd',
            borderLeft: '4px solid #2196F3',
            borderRadius: '4px'
          }}>
            <h3 style={{ marginTop: 0, color: '#1976D2' }}>お知らせ</h3>
            <p style={{ margin: 0, lineHeight: '1.6' }}>
              {data.notification.message_text}
            </p>
            <p style={{ margin: '10px 0 0 0', fontSize: '14px', color: '#666' }}>
              送信日時: {new Date(data.notification.sent_at).toLocaleString('ja-JP')}
            </p>
          </div>

          {/* 応答ボタン */}
          {!submitted ? (
            <div>
              <h3 style={{ marginBottom: '20px', color: '#333' }}>
                現在の状況をお知らせください
              </h3>
              
              <button
                onClick={() => handleSubmit('safe')}
                style={{
                  width: '100%',
                  padding: '20px',
                  marginBottom: '15px',
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  transition: 'transform 0.1s'
                }}
                onMouseDown={(e) => e.target.style.transform = 'scale(0.98)'}
                onMouseUp={(e) => e.target.style.transform = 'scale(1)'}
              >
                ✅ 大丈夫です
              </button>

              <button
                onClick={() => handleSubmit('danger')}
                style={{
                  width: '100%',
                  padding: '20px',
                  marginBottom: '15px',
                  backgroundColor: '#FF9800',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  transition: 'transform 0.1s'
                }}
                onMouseDown={(e) => e.target.style.transform = 'scale(0.98)'}
                onMouseUp={(e) => e.target.style.transform = 'scale(1)'}
              >
                ⚠️ 危ないですが、まだ大丈夫です
              </button>

              <button
                onClick={() => handleSubmit('emergency')}
                style={{
                  width: '100%',
                  padding: '20px',
                  backgroundColor: '#f44336',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  transition: 'transform 0.1s'
                }}
                onMouseDown={(e) => e.target.style.transform = 'scale(0.98)'}
                onMouseUp={(e) => e.target.style.transform = 'scale(1)'}
              >
                🚨 もうだめです。すぐ避難したい
              </button>
            </div>
          ) : (
            <div style={{
              padding: '30px',
              backgroundColor: getStatusColor(selectedStatus) + '15',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <h3 style={{ color: getStatusColor(selectedStatus), marginTop: 0 }}>
                応答完了
              </h3>
              <p style={{ fontSize: '20px', fontWeight: 'bold', margin: '15px 0' }}>
                {getStatusText(selectedStatus)}
              </p>
              <p style={{ color: '#666', margin: 0 }}>
                ご協力ありがとうございました
              </p>
              
              <button
                onClick={() => setSubmitted(false)}
                style={{
                  marginTop: '20px',
                  padding: '10px 30px',
                  backgroundColor: '#2196F3',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '16px'
                }}
              >
                回答を変更する
              </button>
            </div>
          )}
        </div>

        {/* フッター */}
        <div style={{
          marginTop: '20px',
          textAlign: 'center',
          color: '#999',
          fontSize: '14px'
        }}>
          <p>このページは生存確認システムによって生成されました</p>
        </div>
      </div>
    </div>
  );
}

export default ResidentResponse;
